"use client";

// External imports
import {
  Tab as RTab,
  Tabs as RTabs,
  TabList as RTabList,
  TabPanel as RTabPanel,
} from "react-tabs";
import "react-tabs/style/react-tabs.css";

// Local imports
import classes from "./style.module.css";
import FontIcon from "@/app/assets/vectors/FontIcon";
import GlyphsIcon from "@/app/assets/vectors/GlyphsIcon";
import InfoIcon from "@/app/assets/vectors/InfoIcon";
import Preview from "./Preview";
import Glyphs from "./Glyphs";
import Info from "./Info";

// Component prps for Tabs
interface Props {
  fontCssName: string;
  downloadPath: string;
  fontInfo: {
    about: string;
    license: string;
    source: string;
    sourceLink: string;
  };
}

export default function Tabs({ fontCssName, downloadPath, fontInfo }: Props) {
  return (
    <RTabs
      className={`${classes.tabs}`}
      selectedTabClassName={`${classes.tabSelected}`}
    >
      <RTabList className={`${classes.tablist}`}>
        <RTab className={`${classes.tab}`}>
          <FontIcon width={18} height={18} />
          <span>Preview</span>
        </RTab>
        <RTab className={`${classes.tab}`}>
          <GlyphsIcon width={18} height={18} />
          <span>Glyphs</span>
        </RTab>
        <RTab className={`${classes.tab}`}>
          <InfoIcon width={18} height={18} />
          <span>Info</span>
        </RTab>
      </RTabList>

      <RTabPanel className={`${classes.panel}`}>
        <Preview cssName={fontCssName} downloadPath={downloadPath} />
      </RTabPanel>
      <RTabPanel className={`${classes.panel}`}>
        <Glyphs cssName={fontCssName} downloadPath={downloadPath} />
      </RTabPanel>
      <RTabPanel>
        <Info
          about={fontInfo.about}
          license={fontInfo.license}
          source={fontInfo.source}
          sourceLink={fontInfo.sourceLink}
          downloadPath={downloadPath}
        />
      </RTabPanel>
    </RTabs>
  );
}
